<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class PackageBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest

        get items() {
            const getSearchPageLabel = () =>
                `${packagesRuntimeStore.departurePoint.name}, ${packagesRuntimeStore.departurePoint.countryName} - ${
                    packagesRuntimeStore.arrivalPoint.name
                }, ${packagesRuntimeStore.arrivalPoint.countryName} + ${this.$t('hotel', 1)}`
            const addSearchPageLink = items => {
                items.push({
                    title: getSearchPageLabel(),
                    to: packagesRuntimeStore.searchPageLink(this.searchRequest),
                    exact: true,
                })
            }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'packages':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'packageDetail':
                    addSearchPageLink(items)
                    items.push({
                        title: `${packagesStore.selectedHotel.name} + ${this.$t('flights.flight')}`,
                        disabled: true,
                    })
                    break
                case 'packageBooking':
                    addSearchPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'packageConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(PackageBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
